import forEach from 'lodash/forEach'
import isArray from 'lodash/isArray'

/**
 * Return message for HTTP status code
 * @param {number} status - HTTP status code
 * @returns {string} Message of network operation
 */
function _getStatusMessage(status) {
  let message = ''
  switch (status) {
    case 200:
      message = 'All done. Request successfully executed'
      break
    case 201:
      message = 'Data successfully created'
      break
    case 400:
      message = 'Bad Request'
      break
    case 401:
      message = 'Need auth'
      break
    case 404:
      message = 'Not found'
      break
    case 422:
      message = 'Input Auth Error'
      break
    case 503:
      message = 'Service unavailable. Try again later'
      break
    default:
      message = 'Something wrong. Client default error message'
      break
  }
  return message
}

function _getResponseErrorMessage(error) {
  if (error.response && error.response.data) {
    var message = ''
    if (typeof error.response.data.errors.msg === 'object') {
      error.response.data.errors.msg.forEach((element) => {
        message = message + '<li>' + element.msg + '</li>'
      })
    } else {
      message = '<li>' + error.response.data.errors.msg + '</li>'
    }
    return message
  }
  return error.message === 'Network Error'
    ? 'Oops! Network Error. Try again later'
    : error.message
}

/**
 * Create instant, which represent response object
 * @param {Object} [data] - custom data
 * @param {Object} [response] - axios response object
 * @param {String} [message] - custom message to display
 */
export class ResponseWrapper {
  constructor(response, data = {}, message) {
    this.data = data
    this.success = response.data.success
    this.status = response.status
    this.statusMessage = _getStatusMessage(this.status)
    this.message = message || null
  }
}

/**
 * Create instant, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
// eslint-disable-next-line no-unneeded-ternary
export class ErrorWrapper extends Error {
  constructor(error, message) {
    super()
    this.success = error.response && error.response.errors ? 'false' : 'true'
    this.meta = error.response ? error.response.data.meta : false
    this.code = error.response ? error.response.status : false
    if (this.code === 401) {
      window.location.href = '/logout'
    }
    this.status = error.response && error.response.errors ? 'false' : 'true'
    this.statusMessage = _getStatusMessage(this.status)
    this.message = message || _getResponseErrorMessage(error)
  }
}

/**
 * Uses to clear request data before send it
 * Client shouldn't change entity id
 * @param data
 * @return {{}}
 */
export function clearData(data) {
  const result = {}
  forEach(data, (item, propName) => {
    if (isArray(item) && item.length) {
      result[propName] = item
    }
    if (!isArray(item) && item && propName !== 'id') {
      result[propName] = item
    }
  })
  return result
}
